/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import {createOptimizerManagerPayload} from "@/store/payloadHelper.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/optimizer_manager", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/optimizer_manager/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_OPTIMIZER_MANAGER", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/optimizer_manager/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findAll({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/optimizer_manager")
				.then((res) => {
					commit("SET_OPTIMIZER_MANAGER", res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/optimizer_manager/${id}`)
				.then((response) => {
					commit("REMOVE_OPTIMIZER_MANAGER", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	optimizerManagerFilter({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createOptimizerManagerPayload(data);
			Api.post("/optimizer_manager/filter", payload)
				.then((res) => {
					commit("SET_OPTIMIZER_MANAGER", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
